import React, { Component } from "react";
import moment from "moment";
import styleable from 'react-styleable';
import defaultStyle from './legal-section.style';

/**
 * Footer containing copyright, terms of service, and privacy policy
 */
export class LegalSection extends Component {

  render() {
    const { css } = this.props;

    return(
      <div className={css.legalSectionWrapper}>
        <span className={css.text}>&copy; {moment().format('YYYY')} Bonterra</span>
        <span className={css.divider}>|</span>
        <span className={css.text}>
          <a className={css.link} href="https://www.socialsolutions.com/legal/terms-of-service/" target="_blank">Terms of Service</a>
        </span>
        <span className={css.divider}>|</span>
        <span className={css.text}>
          <a className={css.link} href="https://www.socialsolutions.com/legal/privacy-policy/" target="_blank">Privacy Policy</a>
        </span>
      </div>
    );
  }
}

export default styleable(defaultStyle) (LegalSection);



// WEBPACK FOOTER //
// src/common/legal-section/legal-section.js